module.exports = __webpack_public_path__ + "static/media/fujifilm-footer.923e9f4d.jpg";